export const isSmallSlider = (theme) => theme.device !== 'desktop';
